export const validPhoneNumber = RegExp(
  `^[+]*[(]{0,1}[0-9]{1,2}[)]{0,1}[-/0-9]*$`
);
export const validNoOfSiblings = RegExp(`^([0-9]{0,1}|10)$`);
